module.exports = __webpack_public_path__ + "static/img/resume-green.b3219b5.png";